import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

import { environment } from '@Env/environment';

import { DaoGeneric } from '@Services/base/daoService';
import {CommentBdc} from '../index';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommentService extends DaoGeneric<CommentBdc> {
  private url = `${environment.baseUrl}/api_bdc/comments/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  updateOrCreate(comment: CommentBdc) {
    return ('id' in comment  && comment.id > 0) ? this.update(comment) : this.create(comment);
  }

  getByPageAndUser(page = null, user = null): Observable<CommentBdc> {
    if (page && user) {
      const extraParams: Map<string, string> = new Map<string, string>();
      extraParams.set('page', page).set('user', user);
      const params = this._getUrlHttpParams(extraParams);

      const url = `${this.url}by_page_user/`;
      return this.httpClient.get<CommentBdc>(url, { params: params});
    }

    return of(null);
  }
  /**
   * Export All Comments
   */
  public exporyAllComments() {
    const url = `${this.url}export_commentaires/`;
    return this.httpClient.get(url, {
      responseType: 'blob'
    }).pipe(
      map((data: any) => new Blob([data]))
    );
  }
}
